import script from "./investWillAuditApplyDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./investWillAuditApplyDetail.vue?vue&type=script&lang=ts&setup=true"

import "./investWillAuditApplyDetail.vue?vue&type=style&index=0&id=4e3f3262&lang=less"

const __exports__ = script;

export default __exports__